// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1dr1P","cell":"ColumnAccessor_cell__2yhBp","firstCellAccent":"ColumnAccessor_firstCellAccent__2Sg5y"};